export default function (H) {
  H.addEvent(H.Point, 'mouseOver', function (e) {
    const {linkTo} = this.options
    if(linkTo){
      const relatedData=this.series.chart.get(linkTo)
      if(relatedData){
        relatedData.setState('hover')
      }
    }
  })

  H.addEvent(H.Point, 'legendItemClick', function (e) {
    const {linkTo} = this.options
    if(linkTo){
      const relatedData=this.series.chart.get(linkTo)
      if(relatedData){
        relatedData.setVisible(!this.visible)
      }
    }
  })

  H.wrap(H.Legend.prototype, 'renderItem', function (proceed, item) {
    proceed.call(this, item)

    const isPoint = !!item.series
    if (isPoint) {
      //TODO handle also series
      const element = item.legendGroup.element
      //const collection = isPoint ? item.series.points : this.chart.series
      const relatedData = item.linkTo ? item.series.chart.get(item.linkTo) : null

      if (relatedData) {
        element.onmouseover = function () {
          if (item.visible && relatedData) {
            relatedData.series.data.forEach( point =>  point.setState('inactive'))
            relatedData.setState('hover')
          }
        }

        element.onmouseout = function () {
          relatedData.series.data.forEach( point =>  point.setState('normal'))
        }
      }

    }

  })
}
